<span
  class="fi-badge"
  [class]="'fi-badge--' + tone + ' fi-badge--' + size"
  [class.fi-badge--disabled]="disabled"
>
  <img *ngIf="iconBefore" class="fi-badge__icon" [src]="iconBefore" alt="">

  <span class="fi-badge__label"><ng-content></ng-content></span>

  <button
    *ngIf="dismissible"
    type="button"
    class="fi-badge__close"
    [disabled]="disabled"
    (click)="onDismiss()"
    aria-label="Remove"
  >
    <img src="assets/icons/new/close.svg" alt="">
    <span class="u-hidden-visually" fiTranslation="ALT_TEXT_BADGE_DISMISS"></span>
  </button>
</span>
